import * as React from 'react';

import './styles.scss';

const PreloadPanelRow = () => (
  <div className="ph-item ph-item-custom">
    <div className="ph-col-12 big">
      <div className="ph-row">
        <div className="ph-col-2 big" />
        <div className="ph-col-2 empty big" />
        <div className="ph-col-8 big" />
      </div>
    </div>
  </div>
);

export default PreloadPanelRow;
